export default "/institutions/carrefour.svg";